import React from 'react';
import PropTypes from 'prop-types';
import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import '../../Task.scss';
import {useSelector} from 'react-redux';
import {getLabwareDataById} from 'stores/selectors/labwareStateSelectors';
import Spinner from 'components/Spinner/Spinner';
import TaskExecutedTick from 'components/TaskExecutedTick';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import TaskTitle from 'contents/ProtocolEditor/TaskList/Task/Components/TaskTitle';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import TaskPipettingProfileWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskPipettingProfileWrapper';
import {ExecutionStatus, SerialDilutionStep} from 'constants/dataEnum';
import {getSdWellGroupName} from 'stores/business/taskListSerialDilutionBusiness';

import SerialDilutionTransferPipettingProfile from './SerialDilutionTransferPipettingProfile';
import TaskDescriptionSource from './TaskDescriptionSerialDilution';

function TaskDilutionSource({
  task,
  number,
  processedTasks,
  isSelected,
  runtimeMode,
  readOnly,
  executionStatus,
  onEdit,
  onSelectTask,
  showPipettingParameter,
}) {
  // const dispatch = useDispatch();

  // const { aspirateTask, dispenseTask } = task;

  const labware = useSelector(getLabwareDataById(task.labwareID));

  const {volume, row, column, rowTipCount, columnTipCount, number: taskNumber} = task || {};
  const {name: labwareName, rowCount: labwareRowCount, colCount: labwareColumnCount} = labware || {};

  const wellGroupName = getSdWellGroupName(
    row,
    column,
    rowTipCount,
    columnTipCount,
    labwareRowCount,
    labwareColumnCount,
  );

  const isDiluentSourceTransfer = taskNumber === SerialDilutionStep.SET_DILUENT_SOURCE;
  const taskTitle = `Transfer ${isDiluentSourceTransfer ? 'Diluent' : 'Sample'} ${volume}μL`;

  return (
    <TaskWrapper isSelected={isSelected} onClick={onSelectTask}>
      <TaskNumber number={number} isHighlighted={isSelected} />
      <TaskTitle
        title={taskTitle}
        description={<TaskDescriptionSource labwareName={labwareName} wellGroup={wellGroupName} />}
      />
      {!runtimeMode && !readOnly && <TaskAction onEdit={onEdit} />}
      {showPipettingParameter && (
        <TaskPipettingProfileWrapper>
          <SerialDilutionTransferPipettingProfile runtimeMode={runtimeMode} tasks={processedTasks} />
        </TaskPipettingProfileWrapper>
      )}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && <TaskExecutedTick />}
    </TaskWrapper>
  );
}

TaskDilutionSource.propTypes = {
  runtimeMode: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  showPipettingParameter: PropTypes.bool.isRequired,
  executionStatus: PropTypes.string.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
  number: PropTypes.any.isRequired,
  processedTasks: PropTypes.object.isRequired,
};

export default TaskDilutionSource;
